import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ServiceCard from "./components/ServiceCard";
import { useServices } from "../../hooks/useServices";

export default function ServicesPage() {
  const { t } = useTranslation("services");
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { services } = useServices();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <main style={{ background: "#FAF5E8", minHeight: "100vh" }}>
      <Navbar />

      {/* Page Header */}
      <section
        style={{
          paddingTop: 140,
          paddingBottom: 60,
          background: "#ffffff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -80,
            right: -80,
            width: 400,
            height: 400,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(44,95,79,0.06) 0%, transparent 70%)",
          }}
        />
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-center gap-3 mb-6">
            <div style={{ width: 3, height: 24, background: "#2C5F4F", borderRadius: 2 }} />
            <span
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: "0.14em",
                color: "#2C5F4F",
                textTransform: "uppercase",
              }}
            >
              {t("label")}
            </span>
          </div>
          <h1
            style={{
              fontFamily: "'Noto Sans JP', sans-serif",
              fontWeight: 800,
              fontSize: "clamp(28px, 3.5vw, 44px)",
              color: "#1A1A1A",
              lineHeight: 1.3,
              marginBottom: 20,
            }}
          >
            {t("heading")}
          </h1>
          <p
            style={{
              fontFamily: "'Noto Serif JP', serif",
              fontSize: 15,
              color: "#666666",
              lineHeight: 1.9,
              maxWidth: 560,
            }}
          >
            {t("intro")}
          </p>
        </div>
      </section>

      {/* Service Cards Grid */}
      <section
        ref={ref}
        style={{ padding: "80px 0 120px" }}
        data-product-shop
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, i) => (
              <ServiceCard
                key={service.id}
                service={service}
                delay={i * 120}
                visible={visible}
              />
            ))}
          </div>

          {/* Coming Soon Notice */}
          <div
            style={{
              marginTop: 56,
              padding: "32px 40px",
              borderRadius: 16,
              background: "rgba(44,95,79,0.04)",
              border: "1.5px dashed rgba(44,95,79,0.2)",
              display: "flex",
              alignItems: "center",
              gap: 16,
            }}
          >
            <div
              className="flex items-center justify-center w-10 h-10"
              style={{
                borderRadius: "50%",
                background: "rgba(44,95,79,0.1)",
                flexShrink: 0,
              }}
            >
              <i className="ri-time-line" style={{ fontSize: 18, color: "#2C5F4F" }} />
            </div>
            <div>
              <p
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  fontWeight: 600,
                  fontSize: 14,
                  color: "#1A1A1A",
                  marginBottom: 4,
                }}
              >
                {t("comingSoonTitle")}
              </p>
              <p
                style={{
                  fontFamily: "'Noto Serif JP', serif",
                  fontSize: 13,
                  color: "#888888",
                  lineHeight: 1.7,
                }}
              >
                {t("comingSoonBody")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
